<lib-page-layout>
  <lib-title-navbar pageHeader title="Gierki"></lib-title-navbar>
  <div class="games-page">
    <lib-days-range-slider [value]="gamesPeriod()" (valueChange)="setPeriod($event)"></lib-days-range-slider>

    <div class="filter-row">
      <span class="filter-row__label">Typ</span>
      <div class="filter-row__options">
        <button
          class="filter-btn"
          [class.filter-btn--active]="gameType() === AdminGameTypeFilter.SINGLE"
          (click)="setGameType(AdminGameTypeFilter.SINGLE)">
          Jednorazowe
        </button>
        <button
          class="filter-btn"
          [class.filter-btn--active]="gameType() === AdminGameTypeFilter.RECURRING"
          (click)="setGameType(AdminGameTypeFilter.RECURRING)">
          Cykliczne
        </button>
      </div>
    </div>

    <div class="filter-row">
      <span class="filter-row__label">Widoczność</span>
      <div class="filter-row__options">
        <button
          class="filter-btn"
          [class.filter-btn--active]="visibility() === GameVisibility.PUBLIC"
          (click)="setVisibility(GameVisibility.PUBLIC)">
          Publiczne
        </button>
        <button
          class="filter-btn"
          [class.filter-btn--active]="visibility() === GameVisibility.PRIVATE"
          (click)="setVisibility(GameVisibility.PRIVATE)">
          Prywatne
        </button>
      </div>
    </div>

    @if (knownRegions()?.length) {
      <div class="city-accordion" (click)="regionsExpanded.set(!regionsExpanded())">
        <span class="filter-row__label">Region</span>
        <span class="city-accordion__value">{{ region() ?? 'Wszystkie' }}</span>
        <span class="city-accordion__arrow" [class.city-accordion__arrow--open]="regionsExpanded()">&#9662;</span>
      </div>
      @if (regionsExpanded()) {
        <div class="filter-row__options filter-row__options--wrap city-options">
          @for (r of knownRegions(); track r) {
            <button class="filter-btn" [class.filter-btn--active]="region() === r" (click)="setRegion(r)">
              {{ r }}
            </button>
          }
        </div>
      }
    }

    <div class="games-count">Łącznie: {{ gamesCount() }}</div>

    <div class="games-list">
      @for (game of games(); track game.gameId) {
        <div class="game-card">
          <div class="game-card__header">
            <div class="game-card__title">{{ game.name }}</div>
            <div class="game-card__price">{{ game.priceAmount }} PLN</div>
          </div>
          <div class="game-card__location">
            <img src="assets/icons/map/map-marker.svg" class="location-icon" />
            {{ game.location?.name }}
          </div>
          <div class="game-card__date">{{ game.gameDateStart | dateFormat: game.gameDateEnd }}</div>
          <div class="game-card__created">
            Utworzona: {{ game.formattedCreatedAt }}
            @if (game.createdBeforeGame) {
              <span class="game-card__before">({{ game.createdBeforeGame }})</span>
            }
          </div>

          <div class="game-card__stats">
            <div class="stat-item">
              <span class="stat-item__label">Gracze</span>
              <span class="stat-item__value">{{ game.occupiedSlots }}/{{ game.totalSlots }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-item__label">Aplikacje</span>
              <span class="stat-item__value">{{ game.playerApplications?.length }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-item__label">Typ</span>
              <span class="stat-item__value">{{ game.isRecurring ? 'Cykl' : 'Jedno' }}</span>
            </div>
            <div class="stat-item" [class.stat-item--public]="game.visibility === Visibility.PUBLIC">
              <span class="stat-item__label">Status</span>
              <span class="stat-item__value">{{ game.visibility === Visibility.PUBLIC ? 'Pub' : 'Priv' }}</span>
            </div>
          </div>

          <div class="game-card__actions">
            <button class="action-btn action-btn--primary" (click)="goToDetails(game.gameId)">Szczegóły</button>
            <button class="action-btn" [copyToClipboard]="game.host?.hostId">ID Hosta</button>
            <button class="action-btn" [copyToClipboard]="game.gameId">ID Gry</button>
          </div>
        </div>
      }
    </div>
  </div>
</lib-page-layout>
